/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TipiContrattiResDto } from '../../models/tipi-contratti-res-dto';

export interface TipiContrattiControllerFindManyTipiContratti$Params {}

export function tipiContrattiControllerFindManyTipiContratti(
  http: HttpClient,
  rootUrl: string,
  params?: TipiContrattiControllerFindManyTipiContratti$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<Array<TipiContrattiResDto>>> {
  const rb = new RequestBuilder(
    rootUrl,
    tipiContrattiControllerFindManyTipiContratti.PATH,
    'get',
  );
  if (params) {
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<TipiContrattiResDto>>;
      }),
    );
}

tipiContrattiControllerFindManyTipiContratti.PATH = '/tipiContratti';
